import { memo, useMemo } from 'react'
import { Text, Flex, Button } from '@chakra-ui/react'

import { useCalendarFilters } from '../../contexts/CalendarFiltersManager/Provider'
import calculateDatesDifferenceInDays from '../../localUtils/calculateDatesDifferenceInDays'

function ActionsButtons() {
  const { dateFilterType, startDate, finalDate, onClose, onSubmitCalendar } = useCalendarFilters()

  const daysLabel = useMemo(() => {
    const days = Math.abs(calculateDatesDifferenceInDays(startDate, finalDate))

    if (days == 0) return 'Nenhum dia de intervalo'
    if (days == 1) return `${days} dia de intervalo`

    return `${days} dias de intervalo`
  }, [startDate, finalDate])

  const isDateInterval = dateFilterType === 'Intervalo de datas'

  return (
    <Flex width="100%" align="center" gap={2}>
      {isDateInterval && <Text minWidth="max-content">{daysLabel}</Text>}

      <Flex width="100%" align="center" justify="flex-end" gap={2}>
        <Button rounded="xl" variant="outline" onClick={onClose}>
          Cancelar
        </Button>

        <Button rounded="xl" onClick={onSubmitCalendar}>
          Selecionar
        </Button>
      </Flex>
    </Flex>
  )
}

export default memo(ActionsButtons)
